export default "__VITE_ASSET__c744114f__"